import type { JSX } from 'solid-js'

export type FieldErrorProps = Omit<JSX.HTMLAttributes<HTMLParagraphElement>, 'class'>

export const FIELD_MESSAGE_METRICS =
  'text-[length:var(--text-sm)] leading-[var(--leading-snug)] text-pretty'

export const FIELD_MESSAGE_SLOT = 'min-h-[calc(var(--text-sm)*var(--leading-snug))]'

export function FieldError(props: FieldErrorProps) {
  return (
    <p
      {...props}
      data-field-error
      class={`${FIELD_MESSAGE_METRICS} font-[var(--font-medium)] text-[color:var(--color-error-600)]`}
    />
  )
}
